export default __webpack_public_path__ + "static/media/invenimus.6fbdf591.png";